module.exports = __webpack_public_path__ + "static/img/case5.295dc38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case5.png
// module id = Frf0
// module chunks = 3